import { css } from '@/styled-system/css';

export const floorPlanImageWrapper = css({
  position: 'relative',
  width: '100%',
  aspectRatio: '4 / 3',
  borderRadius: '8px',
  overflow: 'hidden',
  marginBottom: '2x',
  backgroundColor: 'hpxGrey100',
});

export const floorPlanImage = css({
  position: 'relative',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block',
});

export const floorPlanImageButton = css({
  display: 'block',
  width: '100%',
  height: '100%',
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
});

export const unitTableHeading = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
  paddingTop: '2x',
  paddingBottom: '1x',
});

export const unitTable = css({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 'sm',
});

export const unitTableHeader = css({
  color: 'hpxGrey600',
  fontWeight: '400',
  textAlign: 'left',
  paddingY: 'xs',
});

export const unitTableRow = css({
  cursor: 'pointer',
  outline: 'none',
  _hover: {
    backgroundColor: 'hpxGrey100',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
  },
});

export const unitTableCell = css({
  paddingY: '1x',
  color: 'hpxBlue600',
});

export const unitNameCell = css({
  paddingY: '1x',
  color: 'hpxTeal500',
  fontWeight: '700',
  cursor: 'pointer',
  fontVariantNumeric: 'tabular-nums',
});

export const carouselContainer = css({
  display: 'block',
  marginTop: '2x',
  md: {
    display: 'none',
  },
});

export const desktopCarouselContainer = css({
  display: 'none',
  md: {
    display: 'block',
    marginTop: '2x',
  },
});

export const desktopCarouselWrapper = css({
  position: 'relative',
});

export const desktopControlsOverlay = css({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  pointerEvents: 'none',
});

export const desktopControlButton = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  border: 'none',
  backgroundColor: 'hpxWhite',
  cursor: 'pointer',
  pointerEvents: 'auto',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  color: 'hpxBlue600',
  transitionProperty: 'background-color, box-shadow',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease',
  _hover: {
    backgroundColor: 'hpxGrey100',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
  _disabled: {
    opacity: 0,
    pointerEvents: 'none',
  },
});

export const compactCard = css({
  height: '100%',
  maxHeight: '612px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const compactImageWrapper = css({
  position: 'relative',
  width: '100%',
  aspectRatio: '4 / 3',
  maxHeight: '280px',
  borderRadius: '8px',
  overflow: 'hidden',
  flexShrink: 0,
  marginBottom: '2x',
  backgroundColor: 'hpxGrey100',
});

export const compactUnitTableWrapper = css({
  flexGrow: 1,
  overflowY: 'auto',
  minHeight: 0,
});

export const bedroomTab = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: '25%',
});

export const unitNameCellContent = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
});

export const unitNameText = css({
  minWidth: '3ch',
});

export const dotContainer = css({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '2x',
  md: {
    display: 'none',
  },
});
